import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import DebounceTableSearch from './DebounceTableSearch';
import CSVDownload from './CSVDownload';
import ResetTable from './ResetTable';
import { Button } from './styles';

export default function Table({
  data,
  page,
  perPage,
  total,
  pagination,
  editPerPege,
  search,
  loading,
  handleExportCSV,
  columns,
  handleFilterSubmit,
  editar,
  reset,
}) {
  const [serverFilter, setServerFilter] = useState([]);
  const estilos = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: '#2a3142',
        },
        paper: {
          backgroundColor: '#2a3142',
          width: '100%',
          maxWidth: '100%',
        },
      },
      MUIDataTableHeadCell: {
        root: {
          backgroundColor: '#2a3142',
        },
      },
      MUIDataTableFilter: {
        root: {
          backgroundColor: '#2A3142',
          width: '500px',
        },
        title: {
          color: '#FFFFFF',
        },
      },
      MuiButton: {
        label: {
          color: '#FFFFFF',
        },
      },
      MuiGridList: {
        root: {
          color: '#FFFFFF',
        },
      },
      MuiTableCell: {
        root: {
          cursor: !editar ? 'default' : 'pointer',
        },
      },
      MuiInputLabel: {
        root: {
          color: '#FFFFFF',
        },
      },
      MuiFormLabel: {
        root: {
          color: '#FFFFFF',
        },
      },
    },
  });

  function handleFilter(filter) {
    const templateFiltro = filter.filter(fil => {
      return fil.length > 0 && fil[0];
    });
    const resultados = templateFiltro.map(resultado => {
      const [coluna, filtro] = resultado[0].split(':');

      return {
        coluna,
        filtro,
      };
    });

    setServerFilter(filter);
    handleFilterSubmit(resultados);
  }

  function handleReset() {
    setServerFilter([]);
    reset();
  }

  const optionsTable = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'standard',
    page: page - 1,
    count: total,
    rowsPerPage: perPage,
    rowsPerPageOptions: [10, 50, 100],
    rowHover: true,
    serverSide: true,
    serverSideFilterList: serverFilter,
    onRowClick: colData => {
      if (editar) {
        editar(colData[0]);
      }
    },
    print: false,
    download: false,
    selectableRows: 'none',
    textLabels: {
      body: {
        noMatch: loading ? 'Carregando' : 'Desculpe, não possui nenhum dado',
        toolTip: 'Ordenar',
      },
      pagination: {
        next: 'Proxima',
        previous: 'Anterior',
        rowsPerPage: 'Dados por página:',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Pesquisar',
        downloadCsv: 'Download CSV',
        print: 'Imprimir',
        viewColumns: 'Ver Colunas',
        filterTable: 'Filtrar tabela',
      },
      filter: {
        all: 'Todos',
        title: 'Filtros',
        reset: 'Resetar',
      },
      selectedRows: {
        text: 'Dado(s) selecionado',
        delete: 'Deletar',
        deleteAria: 'Deletar dados selecionados',
      },
    },
    customToolbar: () => (
      <>
        <CSVDownload handleClick={handleExportCSV} />
        <ResetTable handleClick={handleReset} />
      </>
    ),
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <DebounceTableSearch
          searchText={searchText}
          onSearch={handleSearch}
          onHide={hideSearch}
          options={options}
        />
      );
    },
    onChangePage: number => {
      pagination(number + 1);
    },
    onChangeRowsPerPage: number => {
      editPerPege(number);
    },
    // onFilterChange: (column, filterList, type) => {
    //   if (type === 'custom') {
    //     console.log(filterList);
    //   }
    //   if (type === 'chip') {
    //     handleFilter(filterList);
    //   }
    // },
    onSearchChange: value => {
      search(value);
    },
    customFilterDialogFooter: filterList => {
      return (
        <div style={{ marginTop: '40px' }}>
          <Button onClick={() => handleFilter(filterList)}>
            Aplicar filtro
          </Button>
        </div>
      );
    },
  };

  return (
    <>
      {loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <MuiThemeProvider theme={estilos}>
          <MUIDataTable
            title="teste"
            data={data}
            columns={columns}
            options={optionsTable}
          />
        </MuiThemeProvider>
      )}
    </>
  );
}

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  pagination: PropTypes.func.isRequired,
  editPerPege: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  handleExportCSV: PropTypes.func.isRequired,
  handleFilterSubmit: PropTypes.func.isRequired,
  editar: PropTypes.func,
};

Table.defaultProps = {
  editar: null,
};
